import script from "./rohsDeclarationFormHistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./rohsDeclarationFormHistoryList.vue?vue&type=script&setup=true&lang=js"

import "./rohsDeclarationFormHistoryList.vue?vue&type=style&index=0&id=4d378be6&lang=scss"

const __exports__ = script;

export default __exports__